<template>
    <v-row>
        <v-col cols="12" class="title-section pb-0">
            {{ $t('common.training_time') }}
        </v-col>
        <v-col cols="12">
            <div class="card-container">
                <v-row>
                    <v-col cols="6" class="subtitle-section">
                        {{ $t('common.week') }}
                    </v-col>
                    <v-col cols="6" class="subtitle-section">
                        {{ $t('common.month') }}
                    </v-col>
                    <v-col cols="6" class="text-center border-bottom">
                        <v-icon color="#1d386c" size="36">mdi-av-timer</v-icon>
                        <div class="text-uppercase body-section">
                            {{ $tc('common.minutes', 2) }}
                        </div>
                        <div class="body-section">
                            {{  week | number }}
                        </div>
                    </v-col>
                    <v-col cols="6" class="text-center border-bottom">
                        <v-icon color="#1d386c" size="36">mdi-av-timer</v-icon>
                        <div class="text-uppercase body-section">
                            {{ $tc('common.minutes', 2) }}
                        </div>
                        <div class="body-section">
                            {{  month | number }}
                        </div>
                    </v-col>
                    <v-col cols="12" class="subtitle-section">
                        {{ $t('common.previous_compare') }}
                    </v-col>
                    <v-col cols="6" :class="percentageWeek >= 0 ? 'positive' : 'negative'">
                        {{ percentageWeek >= 0 ? '+' : '' }}{{ percentageWeek }}%
                    </v-col>
                    <v-col cols="6" :class="percentageMonth >= 0 ? 'positive' : 'negative'">
                        {{ percentageMonth >= 0 ? '+' : '' }}{{ percentageMonth }}%
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "TrainingTimeStudent",
    props: {
        counter: {
            type: Object,
            default: null,
        }
    },
    computed: {
        week(vm = this) {
            return vm.counter?.durationWeek || 0
        },
        previousWeek(vm = this) {
            return vm.counter?.durationPreviousWeek || 0
        },
        percentageWeek(vm = this) {
            if(vm.previousWeek <= 0) return 100
            return Number((vm.week - vm.previousWeek) / vm.previousWeek * 100).toFixed(1).replace('.0', '')
        },
        month(vm = this) {
            return vm.counter?.durationMonth || 0
        },
        previousMonth(vm = this) {
            return vm.counter?.durationPreviousMonth || 0
        },
        percentageMonth(vm = this) {
            if(vm.previousMonth <= 0) return 100
            return Number((vm.month - vm.previousMonth) / vm.previousMonth * 100).toFixed(1).replace('.0', '')
        },
    },
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

.card-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 12px;
}

.subtitle-section {
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.border-bottom {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.body-section {
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: #393939;
}

.positive {
    color: #61a319;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
}

.negative {
    color: #ff2e00;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
}

</style>